module.exports = __webpack_public_path__ + "img/drh5_qna_img.d52d6c7f.png";